import styled from 'styled-components';
export const Container = styled.ul `
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    width: 260px;
    background: rgb(32, 32, 32);
    border-radius: 4px;
    color: white;
`;
//# sourceMappingURL=index.js.map